import FormItem from "@components/FormItem/FormItem";
import {
  FORM_FIELDS,
  TEST_ID_BASE,
  type PreNominationRequestFormData,
  type PreNominationRequestLabels,
} from "../constants";

interface PreNominationRequestConfirmationSectionProps {
  labels: PreNominationRequestLabels;
  updateFormData: <K extends keyof PreNominationRequestFormData>(
    key: K,
    value: PreNominationRequestFormData[K],
  ) => void;
}

const PreNominationRequestConfirmationSection = ({
  labels,
  updateFormData,
}: PreNominationRequestConfirmationSectionProps) => (
  <FormItem<PreNominationRequestFormData, typeof FORM_FIELDS.CONFIRMATION>
    testId={`${TEST_ID_BASE}-confirmation-input`}
    name={FORM_FIELDS.CONFIRMATION}
    type="checkbox"
    label={labels.confirmation}
    onFieldChange={updateFormData}
  />
);

export default PreNominationRequestConfirmationSection;
